import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';
import { LocalStorageService } from './local-storage.service';
import { User } from 'src/app/modals/Authentication/auth.models';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  public languages: string[] = ['en', 'nl'];

  constructor(
    public translate: TranslateService, 
    private cookieService: CookieService,
    private localStorageService: LocalStorageService
  ) {
    this.checkAndSet();
  }

  public checkAndSet(newLang=""){

    this.translate.addLangs(this.languages);
    const userData: User = this.localStorageService.getItem('currentUser');

    let locale = environment.locale;
    let browserLang = "";

    if(newLang !== ""){
      browserLang = newLang;
    }
    else if(userData?.lang){
      browserLang = userData?.lang;
    }
    else if (this.cookieService.check('lang')) {
      browserLang = this.cookieService.get('lang');
    }
    else {
      this.setLanguage(locale);
      browserLang = this.translate.getBrowserLang();
    }

    if(this.translate.currentLang !== browserLang){
      const langToUse = browserLang.match(/en|nl/) ? browserLang : locale;
      this.translate.use(langToUse);
      this.setLanguage(langToUse);
    }

  }

  public setLanguage(lang) {
    if(lang == "en" || lang == "nl"){
      this.translate.use(lang);
      this.cookieService.set('lang', lang);
    }
  }

}
